import React, { useRef, useState, useEffect } from "react"
import { useTranslation } from 'react-i18next';


import { useHookStore } from "../../../hook-store/store"
// import { resizeImageFile } from '../../utils/image/image-utils';
import { marks } from '../../../utils/marks';

import "./DiffusionOptionsDesc.css";

import IpaImage1 from "../../../image/for-iopaint/option-description/ipa/ipa-input-h100.jpeg";
import IpaImage2 from "../../../image/for-iopaint/image-prompt/statue-h200.png";
import IpaImage3 from "../../../image/for-iopaint/option-description/ipa/ipa-mask-h100.jpeg";
import IpaImage4 from "../../../image/for-iopaint/option-description/ipa/ipa-output-h100.jpg";

function DiffusionOptionsDescIpa() {
    
    const [t] = useTranslation('translation');
  
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [hStore, hDispatch] = useHookStore();
    const { 
      // inputEta
    } = hStore.iopaintStore;

    return (
      <div className="diffsionOptionDesc">
        <div className="diffsionOptionDescRow">
          {t('diffusionOptions18', 'Use image as input for image inpainting.')}         
          <br/>
          {t('diffusionOptions19', 'Selected part of image is replaced with generated new image that is based on input image and text prompt imput.')}
          <br/>
          {t('diffusionOptions20', 'Image intensity controls strength of image input. Decreasing image intensity reduce effect of image and increse effect of text prompt.')}
          <br/>
          {t('diffusionOptions21', 'Square image is recommended to use.')}
        </div>
        <div className="diffsionOptionDescRow">
          <div className="diffsionOptionDescImages">
            <div>
              <img className="diffsionOptionDescImage"
                src={IpaImage1}
              />
              Input
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={IpaImage2}
              />
              Image Prompt
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={IpaImage3}
              />
              Selected
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={IpaImage4}
              />
              Output
            </div>
          </div>
        </div>
      </div>
    )
  }


export default DiffusionOptionsDescIpa